import { render, staticRenderFns } from "./CustomService.vue?vue&type=template&id=b73cb5ca&"
import script from "./CustomService.vue?vue&type=script&lang=js&"
export * from "./CustomService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports